import { ModulesMap } from '@/config/data/modulesMaps'
import FuelStationsApi from '@/services/apiServiceModules/fuelStationsApi'
import DataTransferModule from '@/services/dataTransferModule'

const fuelStationsApi = new FuelStationsApi()

export default class FuelStationsDt extends DataTransferModule {
	constructor() {
		super(ModulesMap.FUEL_STATIONS, fuelStationsApi,{
			useCache: true,
		})
	}
}